<template>
  <div class="purchase-apply-detail-container">
    <ds-page-header :title="$t('purchaseApplyDetail.page.title')" :subtitle="$t('purchaseApplyDetail.page.subtitle')">
      <template #extra>
        <el-button type="primary" size="small" icon="el-icon-printer" @click="_printPurchaseApply">
          {{ $t('purchaseApplyDetail.print') }}
        </el-button>
        <el-button size="small" icon="el-icon-back" @click="_callBackListPurchaseApply">
          {{ $t('purchaseApplyDetail.back') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- 申请信息 -->
    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('purchaseApplyDetail.applyInfo') }}</span>
        <ds-status-tag size="sm" :type="purchaseApplyDetailInfo.state == '2000' ? 'success' : purchaseApplyDetailInfo.state == '1000' ? 'warning' : 'muted'"
          :label="purchaseApplyDetailInfo.stateName || '-'" />
      </div>
      <div class="ds-info-grid">
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('purchaseApplyDetail.applyNo') }}</span>
          <span class="ds-info-grid__value ds-num">{{ purchaseApplyDetailInfo.applyOrderId || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('purchaseApplyDetail.applicant') }}</span>
          <span class="ds-info-grid__value">{{ purchaseApplyDetailInfo.userName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('purchaseApplyDetail.endUser') }}</span>
          <span class="ds-info-grid__value">{{ purchaseApplyDetailInfo.endUserName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('purchaseApplyDetail.contactPhone') }}</span>
          <span class="ds-info-grid__value ds-num">{{ purchaseApplyDetailInfo.endUserTel || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('purchaseApplyDetail.applyTime') }}</span>
          <span class="ds-info-grid__value ds-num">{{ purchaseApplyDetailInfo.createTime || '-' }}</span>
        </div>
        <div v-if="purchaseApplyDetailInfo.resOrderType == 10000" class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('purchaseApplyDetail.referenceTotalPrice') }}</span>
          <span class="ds-info-grid__value ds-num">{{ formatMoney(purchaseApplyDetailInfo.totalPrice) }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('purchaseApplyDetail.storageMethod') }}</span>
          <span class="ds-info-grid__value">{{
            purchaseApplyDetailInfo.resOrderType == 10000 ?
              (purchaseApplyDetailInfo.warehousingWay == 10000 ? $t('purchaseApplyDetail.directStorage') :
                purchaseApplyDetailInfo.warehousingWay == 20000 ? $t('purchaseApplyDetail.purchaseStorage') :
                  $t('purchaseApplyDetail.emergencyPurchase')) :
              (purchaseApplyDetailInfo.warehousingWay == 10000 ? $t('purchaseApplyDetail.directOutbound') :
                $t('purchaseApplyDetail.auditOutbound')) }}</span>
        </div>
        <div class="ds-info-grid__item ds-info-grid__item--wide">
          <span class="ds-info-grid__label">{{ $t('purchaseApplyDetail.description') }}</span>
          <span class="ds-info-grid__value">{{ purchaseApplyDetailInfo.description || '-' }}</span>
        </div>
        <div v-if="purchaseApplyDetailInfo.resOrderType == 10000" class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('purchaseApplyDetail.referencePurchaseTotalPrice') }}</span>
          <span class="ds-info-grid__value ds-num">{{ purchaseApplyDetailInfo.totalPrice > 0 ? '￥' + purchaseApplyDetailInfo.totalPrice : '-' }}</span>
        </div>
        <div v-if="purchaseApplyDetailInfo.resOrderType == 10000" class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('purchaseApplyDetail.actualPurchaseTotalPrice') }}</span>
          <span class="ds-info-grid__value ds-num">{{ purchaseApplyDetailInfo.purchaseTotalPrice > 0 ? '￥' + purchaseApplyDetailInfo.purchaseTotalPrice : '-' }}</span>
        </div>
      </div>
    </div>

    <!-- 申请物资 -->
    <div class="ds-panel">
      <ds-toolbar :show-column-setting="false" :show-density="false" :show-refresh="false">
        <template #left>
          <span class="ds-panel__title">{{ $t('purchaseApplyDetail.applyMaterials') }}</span>
        </template>
      </ds-toolbar>
      <ds-data-table :data="purchaseApplyDetailInfo.purchaseApplyDetailVo" :density="density" border
        :empty-description="$t('purchaseApplyDetail.page.empty')">
        <el-table-column prop="parentRstName" :label="$t('purchaseApplyDetail.itemType')" align="center" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.parentRstName }} > {{ scope.row.rstName }}
          </template>
        </el-table-column>
        <el-table-column prop="resName" :label="$t('purchaseApplyDetail.itemName')" align="center" min-width="140" />
        <el-table-column prop="shName" :label="$t('purchaseApplyDetail.warehouse')" align="center" min-width="110" />
        <el-table-column prop="specName" :label="$t('purchaseApplyDetail.itemSpec')" align="center" min-width="110">
          <template slot-scope="scope">
            {{ scope.row.specName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="resCode" :label="$t('purchaseApplyDetail.itemCode')" align="center" width="120">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.resCode || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="isFixedName" :label="$t('purchaseApplyDetail.fixedItem')" align="center" width="90" />
        <el-table-column prop="consultPrice" :label="$t('purchaseApplyDetail.referencePrice')" align="center" width="110">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.consultPrice ? '￥' + scope.row.consultPrice : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="quantity" :label="$t('purchaseApplyDetail.applyQuantity')" align="center" width="120">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.quantity }}{{ scope.row.unitCodeName }}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="purchaseApplyDetailInfo.resOrderType == 10000" prop="purchasePrice"
          :label="$t('purchaseApplyDetail.purchasePrice')" align="center" width="110">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.purchasePrice ? '￥' + scope.row.purchasePrice : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="purchaseRemark"
          :label="purchaseApplyDetailInfo.resOrderType == 10000 ? $t('purchaseApplyDetail.purchaseRemark') : $t('purchaseApplyDetail.receiveRemark')"
          align="center" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.purchaseRemark || '-' }}
          </template>
        </el-table-column>
      </ds-data-table>
    </div>

    <!-- 工单流转 -->
    <div v-if="purchaseApplyDetailInfo.warehousingWay == 20000" class="ds-panel">
      <ds-toolbar :show-column-setting="false" :show-density="false" :show-refresh="false">
        <template #left>
          <span class="ds-panel__title">{{ $t('purchaseApplyDetail.workOrderFlow') }}</span>
        </template>
      </ds-toolbar>
      <ds-data-table :data="purchaseApplyDetailInfo.auditUsers" border
        :empty-description="$t('purchaseApplyDetail.page.emptyFlow')">
        <el-table-column type="index" :label="$t('purchaseApplyDetail.serialNumber')" align="center" width="80" />
        <el-table-column prop="userName" :label="$t('purchaseApplyDetail.handler')" align="center" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.userName || scope.row.auditName }}
          </template>
        </el-table-column>
        <el-table-column prop="stateName" :label="$t('purchaseApplyDetail.status')" align="center" width="110">
          <template slot-scope="scope">
            <ds-status-tag size="sm" type="muted" :label="scope.row.stateName || '-'" />
          </template>
        </el-table-column>
        <el-table-column prop="auditTime" :label="$t('purchaseApplyDetail.handleTime')" align="center" width="170">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.auditTime || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="duration" :label="$t('purchaseApplyDetail.timeConsuming')" align="center" width="110" />
        <el-table-column prop="message" :label="$t('purchaseApplyDetail.opinion')" align="center" min-width="160" />
      </ds-data-table>
    </div>

    <audit-div v-if="purchaseApplyDetailInfo.action == 'audit'" ref="auditDiv"></audit-div>
  </div>
</template>

<script>
import { listPurchaseApplys, listWorkflowAuditInfo } from '@/api/resource/purchaseApplyDetailApi'
import { getCommunityId } from '@/api/community/communityApi'
import AuditDiv from '@/components/resource/auditDiv'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'
import { formatMoney } from '@/utils/format'

export default {
  name: 'PurchaseApplyDetailList',
  components: {
    AuditDiv,
    DsPageHeader,
    DsToolbar,
    DsDataTable,
    DsStatusTag
  },
  data() {
    return {
      density: 'default',
      purchaseApplyDetailInfo: {
        resourceNames: '',
        state: '',
        totalPrice: '',
        purchaseTotalPrice: '',
        applyOrderId: '',
        description: '',
        createTime: '',
        userName: '',
        endUserName: '',
        endUserTel: '',
        stateName: '',
        resOrderType: '',
        purchaseApplyDetailVo: [],
        auditUsers: [],
        warehousingWay: '',
        action: '',
        taskId: '',
        flowId: ''
      },
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.purchaseApplyDetailInfo.applyOrderId = this.$route.query.applyOrderId
    this.purchaseApplyDetailInfo.resOrderType = this.$route.query.resOrderType
    this.purchaseApplyDetailInfo.action = this.$route.query.action
    this.purchaseApplyDetailInfo.taskId = this.$route.query.taskId
    this.purchaseApplyDetailInfo.flowId = this.$route.query.flowId
    this._listPurchaseApply()
  },
  methods: {
    formatMoney(v) { return formatMoney(v) },
    async _listPurchaseApply() {
      try {
        const params = {
          applyOrderId: this.purchaseApplyDetailInfo.applyOrderId,
          resOrderType: this.purchaseApplyDetailInfo.resOrderType,
          page: 1,
          row: 1,
          communityId: this.communityId
        }
        const res = await listPurchaseApplys(params)
        const purchaseApply = res.purchaseApplys[0]
        Object.assign(this.purchaseApplyDetailInfo, purchaseApply)

        if (this.purchaseApplyDetailInfo.warehousingWay == 20000) {
          this._loadAuditUser()
        }

        if (this.purchaseApplyDetailInfo.action == 'audit') {
          this.$refs.auditDiv.open({
            createUserId: purchaseApply.createUserId,
            action: this.purchaseApplyDetailInfo.action,
            taskId: this.purchaseApplyDetailInfo.taskId,
            flowId: this.purchaseApplyDetailInfo.flowId,
            url: '/purchaseApply.auditApplyOrder',
            id: purchaseApply.applyOrderId,
          })
        }
      } catch (error) {
        console.error('获取采购申请详情失败:', error)
      }
    },
    async _loadAuditUser() {
      try {
        const params = {
          businessKey: this.purchaseApplyDetailInfo.applyOrderId,
          communityId: this.communityId
        }
        const res = await listWorkflowAuditInfo(params)
        this.purchaseApplyDetailInfo.auditUsers = res.data
      } catch (error) {
        console.error('获取审核流程信息失败:', error)
      }
    },
    _callBackListPurchaseApply() {
      this.$router.go(-1)
    },
    _printPurchaseApply() {
      if (this.purchaseApplyDetailInfo.resOrderType == '10000') {
        window.open(`/#/pages/property/printPurchaseApply?applyOrderId=${this.purchaseApplyDetailInfo.applyOrderId}&resOrderType=${this.purchaseApplyDetailInfo.resOrderType}`)
      } else if (this.purchaseApplyDetailInfo.resOrderType == '20000') {
        window.open(`/#/pages/property/printPurchaseOutApply?applyOrderId=${this.purchaseApplyDetailInfo.applyOrderId}&resOrderType=${this.purchaseApplyDetailInfo.resOrderType}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.purchase-apply-detail-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);

  &--padded {
    padding: var(--ds-spacing-lg);
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: var(--ds-spacing-md);
    margin-bottom: var(--ds-spacing-lg);
    border-bottom: 1px solid var(--ds-gray-200);
  }

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}

.ds-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: var(--ds-spacing-md) var(--ds-spacing-lg);

  &__item {
    display: flex;
    flex-direction: column;
    gap: 4px;

    &--wide {
      grid-column: 1 / -1;
    }
  }

  &__label {
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-500);
  }

  &__value {
    font-size: var(--ds-font-size-md);
    color: var(--ds-gray-800);
    word-break: break-all;
  }
}
</style>
